import type { TemplateProps } from '../types';
import { DefaultPanel } from '../../components/DefaultPanel';
import type { WidgetConfig } from '../../lib/types';

function MinimalDockHeader(config: WidgetConfig, onClear: () => void, onClose: () => void): preact.JSX.Element {
  return (
    <div class="yd-dock-header">
      <span class="yd-dock-header-name">{config.name}</span>
      <div class="yd-dock-header-actions">
        <button
          class="yd-dock-header-btn"
          onClick={onClear}
          title="Clear conversation"
          aria-label="Clear conversation"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          </svg>
        </button>
        <button
          class="yd-dock-header-btn"
          onClick={onClose}
          title="Close"
          aria-label="Close chat"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    </div>
  );
}

export function Panel(props: TemplateProps): preact.JSX.Element {
  return <DefaultPanel {...props} className="yd-dock-panel" renderHeader={MinimalDockHeader} />;
}
